import { useAuthStore } from "@persisted-state/auth/auth.store";

const SHIPPER_ROLE = "dry-bulk-shipper";
const SHIPPING_AGENT_ROLE = "shipping-agent";
const OPERATIONS_ROLE = "operations";

/**
 * DBCO-0040 - whether the logged-in user acts as a Shipper in cargo ops. Same precedence as bff-drybulk-cargo-ops'
 * `Role` (operations > shipping-agent > dry-bulk-shipper): a user holding either higher role is not a Shipper here.
 */
export const useIsCargoOpsShipper = (): boolean =>
  useAuthStore((state) => {
    const roles = state.user?.roles ?? [];
    return (
      roles.includes(SHIPPER_ROLE) &&
      !roles.includes(SHIPPING_AGENT_ROLE) &&
      !roles.includes(OPERATIONS_ROLE)
    );
  });
